import { cx } from "@jugl-web/utils";
import { parseChatMarkdown } from "@jugl-web/domain-resources/chat-bot/utils/parseChatMarkdown";
import React from "react";
import { Avatar } from "@jugl-web/ui-kit";
import { ChatBotPreviewMessage } from "../../types";
import { ChatBotPreviewTheme } from "../../consts";

export const ChatBotPreviewMessageBubble: React.FC<{
  message: ChatBotPreviewMessage;
  showAvatar: boolean;
  theme: ChatBotPreviewTheme;
}> = ({ message, showAvatar, theme }) => (
  <div
    className={cx(
      "flex items-end gap-1",
      message.isOutgoing && "flex-row-reverse"
    )}
  >
    {showAvatar && <Avatar username="" size="sm" imageUrl={message.avatar} />}
    <div
      className={cx(
        "mt-6 flex w-max max-w-[240px] flex-col gap-[5px] rounded-2xl p-4",
        message.isOutgoing
          ? cx("ml-auto rounded-br-none bg-primary", theme.outgoingBg)
          : cx("rounded-bl-none bg-grey-100", theme.incomingBg)
      )}
    >
      <span
        className={cx(
          "truncate font-secondary text-sm leading-[140%] font-medium",
          message.isOutgoing ? theme.outgoingNickColor : "text-dark-600"
        )}
      >
        {message.username}
      </span>
      <span
        className={cx(
          "font-secondary text-sm leading-[140%] break-words whitespace-pre-wrap",
          message.isOutgoing ? theme.outgoingTextColor : "text-dark"
        )}
      >
        {parseChatMarkdown({ raws: message.text })}
      </span>
    </div>
  </div>
);
